module.exports = __webpack_public_path__ + "static/media/business_product_8.63fbd65b.png";